/* WISHLIST SAVE CONFIRMATION (Oct 26-28 2026, Chris). Every save gets a small confirmation card, Ralph Lauren style:
     Desktop and tablet (700px+): the card drops down from the header heart, built on the account panel's own
       style (.tt-ap in tt-filter.css: same width, shadow, arrow and drop-in), so hovering the account icon and
       saving to the wishlist feel like one family.
     Phones: the same card slides up from the bottom.
   Signed in: "Added to Your Wishlist", the piece (photo, name, colour | size), View Wishlist (n). Closes itself
     after a few seconds (not while the pointer is on it).
   Guests save up to 5 pieces on this device (GUEST_ITEM_LIMIT in swym-wishlist.js):
     Saves 1-5: the same card plus one line and Sign In / Create Account, which opens the My Account drawer
       (tt-account.js) on the Create Account tab. Stays until closed.
     The 6th save: "Sign In to Save This Item to Your Wishlist" and why (five items until you sign in); nothing is saved yet. Once they sign in or
       create an account, the piece saves on its own and the drawer's account view leads with it.
   No "guests", no "limit": the copy sells keeping the wishlist on every device and saving as many pieces as they
   like. No sign-in anywhere on the wishlist page itself (Chris).
   Guests' header heart (Oct 28): hover (desktop, mouse) shows a panel built like the account panel; a click or tap
   opens the My Account drawer on Sign In (Create Account one tab over) with a Your Wishlist card and View Wishlist (n).
   Every Sign In / Create Account here is the account panel's own data-tt-account link, opened by tt-account.js.
   Oct 31 (Chris, approved mock-up "Guest Panel And Wishlist"): cards and the heart hover redrawn in the account
   panel's language (.tt-wl below): outline heart + caps title, the piece between hairlines (4:5 photo), one
   sentence, Sign In (navy) over Create Account (outlined), stacked, View Wishlist underlined. 380px wide, the
   same as the guest account panel. Same words.
   Nov 1 (Chris, mock-up "Guest And Wishlist States"): titles in Inter Medium, like the member panel. Guests see the
   Sign In invitation on their first save of a visit only; later saves get the same quiet card as members
   ('quiet'). Phones: every save opens the sheet from the bottom (Chris, Nov 1: the slim bar was tried and dropped);
   member and repeat saves close themselves after 4s. */
(function () {
  'use strict';
  var config = (window.themeVariables && window.themeVariables.wishlist) || {};
  var PAGE = config.pageUrl || '/pages/wishlist';
  var drawer = document.getElementById('tt-account-drawer');
  var signedOut = !!(drawer && drawer.querySelector('[data-tt-acct-tabs]')) && !config.isLoggedIn;
  var DESKTOP = window.matchMedia('(min-width: 700px)');
  var XICON = '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
  var COPY = 'Sign in to save all of your favorites and keep track of them across all of your devices.'; // Chris, Oct 28: "across all of your devices"
  var REWARDS = ''; // no rewards line on the wishlist cards (Chris, Oct 28: cluttered)
  // The 6th save is a request, not a confirmation (Chris, Oct 28): the headline asks, and this line says why.
  var SIXTH = 'Your wishlist holds five items until you sign in. Sign in to save this one and keep track of all of your favorites across all of your devices.';

  // Sign In and Create Account side by side, as in the account panel. Plain data-tt-account links: tt-account.js
  // opens the drawer on the right tab, the same way it does for the account panel.
  var BUTTONS = '<div class="tt-wl__btns"><a class="tt-wl__btn" href="/account/login" data-tt-account="signin" data-wl-src>Sign In</a>' +
    '<a class="tt-wl__btn tt-wl__btn--o" href="/account/register" data-tt-account="create" data-wl-src>Create Account</a></div>';
  var HEART = '<svg class="tt-wl__hrt" aria-hidden="true" focusable="false" viewBox="0 0 24 22"><path d="M12 20.5s-8.5-5.2-10.2-10.4C.6 6.4 2.9 2.5 6.7 2.1c2.2-.2 4.1.9 5.3 2.7 1.2-1.8 3.1-2.9 5.3-2.7 3.8.4 6.1 4.3 4.9 8-1.7 5.2-10.2 10.4-10.2 10.4z" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';

  var pending = null;      // the 6th save, waiting for sign-in
  // Nov 1 (Chris): signing in from the heart (its hover panel, or the drawer the heart opens) goes to the wishlist
  // once signed in, not the account view. Signing in from a save card stays put; the 6th save still saves the piece.
  var toWishlist = false;
  var savedShown = false;  // confirmation waiting in the drawer's account view
  var tapped = 0;          // last tap on a heart or its size picker
  var card = null, sheet = null, timer = null, current = null;

  var style = document.createElement('style');
  style.textContent = [
    '.tt-wlc{z-index:30}',
    '.tt-wlc.is-fixed{position:fixed;top:16px;inset-inline-end:24px}',
    '.tt-wlc.is-fixed:after{display:none}',
    /* The cards and the heart hover (Oct 31). Type: T2 title 16px caps, T3 sentence 14px light, 12px caps labels,
       T7 13px light muted; 44px buttons, 13px caps. */
    '.tt-ap.tt-wlc,.tt-ap.tt-whp{width:380px}',
    '.tt-wl{display:flex;flex-direction:column;padding:28px;color:#041e3a;text-align:start}',
    '.tt-wl p{margin:0}',
    '.tt-wl>:last-child{margin-bottom:0!important}',
    '.tt-wl__h{display:flex;align-items:flex-start;gap:7.2px;margin-bottom:20px}',
    '.tt-wl__hrt{flex:0 0 auto;width:24px;height:22px;margin-top:1px}',
    '.tt-wl__t2{flex:1;min-width:0;font-size:16px;font-weight:500;line-height:1.4;letter-spacing:.04em;text-transform:uppercase}',
    '.tt-wl__x{display:grid;place-items:center;flex:0 0 auto;width:28px;height:28px;margin:-3px -7px 0 0;padding:0;border:0;background:none;color:#041e3a;cursor:pointer}',
    '.tt-wl__item{display:flex;gap:16px;align-items:center;padding:16px 0;border-block:1px solid rgba(4,30,58,.1);margin-bottom:20px}',
    '.tt-wl__th{display:block;flex:0 0 auto;width:72px;aspect-ratio:4/5;background:#eef0f3;overflow:hidden}',
    '.tt-wl__th img{display:block;width:100%;height:100%;object-fit:cover;object-position:center 15%;mix-blend-mode:multiply}',
    '.tt-wl__name{font-size:12px;font-weight:400;line-height:1.4;letter-spacing:.06em;text-transform:uppercase}',
    '.tt-wl__var{font-size:13px;font-weight:300;line-height:1.5;color:rgba(4,30,58,.55)}',
    '.tt-wl__lede{font-size:14px;font-weight:300;line-height:1.5;margin-bottom:20px!important}',
    '.tt-wl__btns{display:grid;grid-template-columns:minmax(0,1fr);gap:8px;margin-bottom:20px}',
    '.tt-wl__btn{height:44px;display:grid;place-items:center;padding:0 16px;border:1px solid #041e3a;border-radius:2px;background:#041e3a;color:#fff!important;font-size:13px;font-weight:400;letter-spacing:.04em;text-transform:uppercase;text-decoration:none;white-space:nowrap;transition:background-color .2s,color .2s}',
    '.tt-wl__btn:hover,.tt-wl__btn--o{background:#fff;color:#041e3a!important}',
    '.tt-wl__btn--o:hover{background:#041e3a;color:#fff!important}',
    '.tt-wl__u{align-self:flex-start;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#041e3a;text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:4px;white-space:nowrap}',
    /* The drawer's wishlist cards (after signing in, and the heart's drawer view). */
    '.tt-wlc__img{flex:none;width:56px;aspect-ratio:2/3;background:#f3f3f3;overflow:hidden}',
    '.tt-wlc__img img{width:100%;height:100%;object-fit:cover;display:block}',
    '.tt-wlc__name{font-size:13px;font-weight:500;line-height:1.4}',
    '.tt-wlc__var{font-size:13px;font-weight:300;line-height:1.4;color:#041e3acc}',
    '.tt-wlc__cta{display:flex;flex-direction:column;gap:12px}',
    '.tt-wlc__t{font-size:13px;font-weight:300;line-height:1.5}',
    '.tt-wlc__link{align-self:center;padding:4px 0;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#041e3a;text-decoration:underline;text-underline-offset:3px}',
    /* Phones: a sheet from the bottom, same inside. */
    '.tt-wls{position:fixed;inset:0;z-index:1000}',
    '.tt-wls[hidden]{display:none}',
    'html.tt-wls-open #zendesk-launcher{display:none!important}',
    '.tt-wls__ov{position:absolute;inset:0;background:#041e3a66;opacity:0;transition:opacity .2s}',
    '.tt-wls__panel{position:absolute;inset-inline:0;bottom:0;background:#fff;color:#041e3a;padding-bottom:calc(36px + env(safe-area-inset-bottom, 0px));transform:translateY(100%);transition:transform .25s ease-out}',
    '.tt-wls.is-open .tt-wls__ov{opacity:1}',
    '.tt-wls.is-open .tt-wls__panel{transform:none}',
    '.tt-wls__grab{width:40px;height:4px;border-radius:2px;background:#c9ced4;margin:8px auto 0}',
    '.tt-wls .tt-wl{padding:22px 24px 0}',
    /* iPhone Safari: with its toolbar minimised, the first tap near the bottom edge only brings the toolbar back
       (Oct 28: View Wishlist needed two taps). The sheet's last button sits 36px above that zone, with a taller tap area. */
    '.tt-wls .tt-wl__u{padding-block:12px;margin-block:-12px}',
    /* After signing in from the 6th save: the piece leads the drawer's account view. */
    '.tt-acct__wlsaved{display:flex;gap:14px;align-items:center;padding:20px 24px;background:#f5f6f8;border-bottom:1px solid #e6e6e6}',
    '.tt-acct__wlsaved p{margin:0}'
  ].join('\n');
  document.head.appendChild(style);

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  // Title, colour, size and image of the piece, from the product's own data.
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function loadInfo(product) {
    var path;
    try { path = new URL(product.du, window.location.origin).pathname.replace(/\/$/, ''); } catch (e) { return Promise.resolve(null); }
    return fetch(path + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(product.epi); })[0] || null;
        var names = (p.options || []).map(function (o) { return String(o.name || o).toLowerCase(); });
        var color = '', size = '';
        if (v) names.forEach(function (n, i) {
          var val = v['option' + (i + 1)];
          if (/colou?r/.test(n)) color = val; else if (/size/.test(n)) size = val;
        });
        var image = (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
        return { title: p.title, color: color, size: size, image: sized(image, 160) };
      })
      .catch(function () { return null; });
  }

  function listCount() {
    var wl = window.themeWishlist;
    return wl && wl.state && wl.state.keys ? wl.state.keys.size : 0;
  }

  // ---- The card ----
  // Nov 1 (Chris): a saved piece gets the filled heart; the outline stays for the heart hover and the 6th save.
  function head(title, x, filled) {
    return '<div class="tt-wl__h">' + (filled ? HEART.replace('fill="none" stroke="currentColor" stroke-width="1.2"', 'fill="currentColor"') : HEART) + '<p class="tt-wl__t2" id="tt-wlc-h">' + title + '</p>' +
      (x ? '<button type="button" class="tt-wl__x" data-wlc-close aria-label="Close">' + XICON + '</button>' : '') + '</div>';
  }
  function inner(mode, info, count) {
    var line = info ? [info.color, info.size ? 'Size ' + info.size : ''].filter(Boolean).join(' | ') : '';
    var n = count ? ' (' + count + ')' : '';
    var item = '<div class="tt-wl__item"><span class="tt-wl__th">' + (info && info.image ? '<img src="' + esc(info.image) + '" alt="">' : '') + '</span>' +
      '<div><p class="tt-wl__name">' + esc(info ? info.title : '') + '</p>' + (line ? '<p class="tt-wl__var">' + esc(line) + '</p>' : '') + '</div></div>';
    return '<div class="tt-wl">' + head(mode === 'save' ? 'Sign In to Save This Item to Your Wishlist' : 'Added to Your Wishlist', true, mode !== 'save') + item +
      (mode === 'signed' || mode === 'quiet' ? '<a class="tt-wl__btn" href="' + esc(PAGE) + '">View Wishlist' + n + '</a>' :
        '<p class="tt-wl__lede">' + (mode === 'save' ? SIXTH : COPY + REWARDS) + '</p>' + BUTTONS +
        '<a class="tt-wl__u" href="' + esc(PAGE) + '">View Wishlist' + n + '</a>') +
      '</div>';
  }

  function heartSlot() {
    var li = document.querySelector('.header__wishlist-link');
    if (!li) return null;
    var r = li.getBoundingClientRect();
    return r.width ? { li: li, offscreen: r.bottom <= 0 } : null;
  }

  function close() {
    clearTimeout(timer);
    document.removeEventListener('keydown', onKey, true);
    document.removeEventListener('pointerdown', onOutside, true);
    if (card) { card.remove(); card = null; }
    if (sheet) {
      var s = sheet; sheet = null;
      document.documentElement.classList.remove('tt-wls-open');
      s.classList.remove('is-open');
      setTimeout(function () { s.remove(); }, 260);
    }
    current = null;
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function onOutside(e) {
    var box = card || (sheet && sheet.querySelector('.tt-wls__panel'));
    if (box && !box.contains(e.target)) close();
  }
  function autoClose() {
    clearTimeout(timer);
    if (current && (current.mode === 'signed' || current.mode === 'quiet')) timer = setTimeout(close, sheet ? 4000 : 5000);
  }

  function wire(root) {
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-wlc-close]')) { close(); return; }
      if (e.target.closest('a[data-tt-account]')) { pending = current && current.mode === 'save' ? current.product : null; close(); }
    });
    root.addEventListener('pointerenter', function () { clearTimeout(timer); });
    root.addEventListener('pointerleave', autoClose);
    root.addEventListener('focusin', function () { clearTimeout(timer); });
  }

  function show(mode, product, count) {
    close();
    hideHover();
    current = { mode: mode, product: product, count: count };
    var mine = current;
    var paint = function (info) {
      if (current !== mine) return;
      var slot = DESKTOP.matches ? heartSlot() : null;
      if (slot) {
        card = document.createElement('div');
        card.className = 'tt-ap tt-wlc' + (slot.offscreen ? ' is-fixed' : '');
        card.setAttribute('role', 'dialog');
        card.setAttribute('aria-labelledby', 'tt-wlc-h');
        card.innerHTML = inner(mode, info, count);
        // Same drop line as the account panel: the card's top sits on the header's bottom edge.
        var hdr = slot.li.closest('header, .header');
        if (hdr && !slot.offscreen) card.style.setProperty('--tt-ap-gap', Math.max(12, Math.round(hdr.getBoundingClientRect().bottom - slot.li.getBoundingClientRect().bottom)) + 'px');
        if (slot.offscreen) document.body.appendChild(card); else slot.li.appendChild(card);
        wire(card);
        var ap = document.querySelector('[data-tt-ap]:not([hidden])'); // the account panel steps aside
        if (ap) ap.hidden = true;
      } else {
        sheet = document.createElement('div');
        sheet.className = 'tt-wls';
        sheet.innerHTML = '<div class="tt-wls__ov"></div><div class="tt-wls__panel" role="dialog" aria-labelledby="tt-wlc-h"><div class="tt-wls__grab" aria-hidden="true"></div>' + inner(mode, info, count) + '</div>';
        document.body.appendChild(sheet);
        document.documentElement.classList.add('tt-wls-open'); // Zendesk's chat button steps aside, as it does for the drawers
        wire(sheet.querySelector('.tt-wls__panel'));
        requestAnimationFrame(function () { requestAnimationFrame(function () { if (sheet) sheet.classList.add('is-open'); }); });
      }
      document.addEventListener('keydown', onKey, true);
      setTimeout(function () { if (current === mine) document.addEventListener('pointerdown', onOutside, true); }, 0);
      autoClose();
    };
    // Wait briefly for the photo and name so the card opens complete; open anyway after 700ms.
    var done = false;
    var go = function (info) { if (done) return; done = true; paint(info); };
    loadInfo(product).then(go);
    setTimeout(function () { go(null); }, 700);
  }

  // Our Sign In / Create Account links: once tt-account.js has opened the drawer, name the source for Klaviyo.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a[data-wl-src]') && window.ttAccountDrawer && window.ttAccountDrawer.source) {
      setTimeout(function () { window.ttAccountDrawer.source('Wishlist'); }, 0); // "Account Created From" in Klaviyo
    }
  });

  // Close when the account panel opens beside it.
  var ap = document.querySelector('[data-tt-ap]');
  // Exception: while the pointer is on the wishlist panel (passing over the account icon on the way down to it, the
  // icons are 20px apart), the account panel steps back instead, so one hover never replaces the other mid-reach.
  if (ap) new MutationObserver(function () {
    if (ap.hidden) return;
    if (hp && !hp.hidden && hp.matches(':hover')) { if (window.ttAccountPanel) window.ttAccountPanel.hide(); return; }
    if (card) close();
    hideHover();
  }).observe(ap, { attributes: true, attributeFilter: ['hidden'] });

  // ---- Guests: the header heart works like the account icon (Oct 28, Chris) ----
  // Click (desktop and phones): the My Account drawer, Create Account tab, with a Your Wishlist card on top and
  // View Wishlist (n) so saved pieces stay one tap away. Desktop with a mouse: hovering the heart shows a panel
  // in the account panel's style. Signed in: neither; the heart goes straight to the wishlist.
  var FILLED = '<svg aria-hidden="true" focusable="false" width="26" height="24" viewBox="0 0 24 22"><path d="M12 20.6 10.6 19.3C5.4 14.6 2 11.5 2 7.6 2 4.5 4.4 2 7.5 2c1.7 0 3.4.8 4.5 2.1C13.1 2.8 14.8 2 16.5 2 19.6 2 22 4.5 22 7.6c0 3.9-3.4 7-8.6 11.7L12 20.6Z" fill="currentColor"/></svg>';
  var viewLink = function () { var n = listCount(); return n ? '<a class="tt-wlc__link" style="align-self:flex-start" href="' + esc(PAGE) + '">View Wishlist (' + n + ')</a>' : ''; };
  var dcard = null;
  if (signedOut && drawer) {
    style.textContent += '\n.tt-acct__wl{display:none;gap:16px;align-items:center;padding:22px 24px;background:#f5f6f8;border-bottom:1px solid #e6e6e6;color:#041e3a}' +
      '\n#tt-account-drawer.tt-wl-on:has([data-tt-acct-view="signin"]:not([hidden])) .tt-acct__wl,#tt-account-drawer.tt-wl-on:has([data-tt-acct-view="create"]:not([hidden])) .tt-acct__wl{display:flex}' +
      '\n.tt-acct__wl p{margin:0}' +
      // Nov 1 (Chris): on the Create Account tab the line ends ", or create an account below".
      '\n#tt-account-drawer:has([data-tt-acct-view="create"]:not([hidden])) .tt-wl-si,#tt-account-drawer:not(:has([data-tt-acct-view="create"]:not([hidden]))) .tt-wl-ca{display:none}';
    var body = drawer.querySelector('.tt-acct__body');
    if (body) {
      dcard = document.createElement('div');
      dcard.className = 'tt-acct__wl';
      body.insertBefore(dcard, body.firstChild);
    }
  }
  function openDrawerView() {
    hideHover();
    close();
    pending = null;
    toWishlist = true;
    if (dcard) {
      dcard.innerHTML = FILLED + '<div class="tt-wlc__cta" style="gap:6px"><p class="tt-ap__h" style="font-size:12px">Your Wishlist</p>' +
        '<p class="tt-wlc__t tt-wl-si">' + COPY + REWARDS + '</p>' +
        '<p class="tt-wlc__t tt-wl-ca">' + COPY.replace(/\.$/, ', or create an account below.') + '</p>' + viewLink() + '</div>';
      drawer.classList.add('tt-wl-on');
    }
    if (window.ttAccountDrawer.source) window.ttAccountDrawer.source('Wishlist');
    window.ttAccountDrawer.open('signin', false);
  }
  if (drawer) {
    // Only touch the class when it is there: removing an absent class still rewrites the attribute, which would
    // wake this observer again and loop forever (that froze the drawer on Oct 28).
    new MutationObserver(function () { if (!drawer.classList.contains('is-open') && drawer.classList.contains('tt-wl-on')) drawer.classList.remove('tt-wl-on'); })
      .observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  // Any other Sign In / Create Account link opens the drawer without the wishlist card.
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('a[data-tt-account]')) return;
    // The heart's hover panel; any other Sign In / Create Account outside the drawer is not (links inside the drawer
    // only switch its tab).
    if (!e.target.closest('#tt-account-drawer')) toWishlist = !!e.target.closest('.tt-whp');
    if (drawer && drawer.classList.contains('tt-wl-on')) drawer.classList.remove('tt-wl-on');
  }, true);

  // ONLY the header heart and the phone menu's Wishlist link, signed out. Every other wishlist link (the empty bag's
  // View Your Wishlist, our cards and hover panel, the account pages) goes straight to the wishlist page (Oct 28 fix).
  document.addEventListener('click', function (e) {
    if (!signedOut || !window.ttAccountDrawer || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link || link.closest('.tt-wlc, .tt-wls, .tt-acct__wl, .tt-whp')) return;
    if (!link.closest('.header__wishlist-link, #sidebar-menu, .header-sidebar')) return;
    var href;
    try { href = new URL(link.getAttribute('href'), window.location.origin); } catch (err) { return; }
    if (href.origin !== window.location.origin || href.pathname !== PAGE || href.searchParams.get('lid')) return;
    e.preventDefault();
    e.stopPropagation();
    openDrawerView();
  }, true);

  // Desktop hover panel on the heart: built and run exactly like the account panel (tt-drawer.js, ttAccountPanel),
  // so the two behave the same. Mouse: opens after a short pause, closes a moment after the pointer leaves (the
  // .tt-ap bridge covers the gap down to the panel). Keyboard: opens on focus, Escape closes. Touch: no hover;
  // a tap on the heart opens the drawer. Sign In / Create Account are the account panel's own kind of link.
  var hp = null, hpOpen = null, hpShut = null;
  var WIDE = window.matchMedia('(min-width: 700px)');
  var CANHOVER = window.matchMedia('(hover: hover)');
  function hideHover() {
    clearTimeout(hpOpen); clearTimeout(hpShut);
    if (hp && !hp.hidden) hp.hidden = true;
  }
  function setupHover(li) {
    if (hp || !li) return;
    hp = document.createElement('div');
    hp.className = 'tt-ap tt-whp';
    hp.hidden = true;
    li.appendChild(hp);
    var link = li.querySelector('a');
    function off() { return !WIDE.matches || !signedOut || !!card; }
    function place() {
      var header = li.closest('.header') || li.closest('header');
      if (header) hp.style.setProperty('--tt-ap-gap', Math.max(8, Math.round(header.getBoundingClientRect().bottom - li.getBoundingClientRect().bottom)) + 'px');
    }
    function fill() {
      var n = listCount();
      hp.innerHTML = '<div class="tt-wl">' + head('Your Wishlist', false) + '<p class="tt-wl__lede">' + COPY + '</p>' + BUTTONS +
        (n ? '<a class="tt-wl__u" href="' + esc(PAGE) + '">View Wishlist (' + n + ')</a>' : '') + '</div>';
    }
    function show() {
      clearTimeout(hpOpen); clearTimeout(hpShut);
      if (!hp.hidden || off()) return;
      if (ap && !ap.hidden && window.ttAccountPanel) window.ttAccountPanel.hide();
      fill(); place();
      hp.hidden = false;
    }
    li.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !CANHOVER.matches) return;
      clearTimeout(hpShut);
      if (hp.hidden) hpOpen = setTimeout(show, 150);
    });
    li.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(hpOpen);
      hpShut = setTimeout(hideHover, 300);
    });
    document.addEventListener('pointerdown', function (e) { if (!hp.hidden && !li.contains(e.target)) hideHover(); }, true);
    if (link) link.addEventListener('focus', function () { if (link.matches(':focus-visible')) show(); });
    li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) hpShut = setTimeout(hideHover, 150); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideHover(); });
    hp.addEventListener('click', function (e) { if (e.target.closest('[data-tt-account]')) hideHover(); });
  }
  if (signedOut) {
    setupHover(document.querySelector('.header__wishlist-link'));
  }

  // ---- After signing in from the 6th save: the piece saves, and leads the drawer's account view ----
  function clearSaved() {
    var old = drawer && drawer.querySelector('.tt-acct__wlsaved');
    if (old) old.remove();
  }
  function showSaved(info, count) {
    clearSaved();
    var done = drawer && drawer.querySelector('[data-tt-acct-view="done"]');
    if (!done) return;
    var line = info ? [info.color, info.size ? 'Size ' + info.size : ''].filter(Boolean).join(' | ') : '';
    var box = document.createElement('div');
    box.className = 'tt-acct__wlsaved';
    box.innerHTML = '<div class="tt-wlc__img">' + (info && info.image ? '<img src="' + esc(info.image) + '" alt="">' : '') + '</div>' +
      '<div class="tt-wlc__cta" style="gap:6px"><p class="tt-ap__h" style="font-size:12px">Added to Your Wishlist</p>' +
      (info ? '<p class="tt-wlc__name">' + esc(info.title) + '</p>' : '') + (line ? '<p class="tt-wlc__var">' + esc(line) + '</p>' : '') +
      '<a class="tt-wlc__link" style="align-self:flex-start" href="' + esc(PAGE) + '">View Wishlist' + (count ? ' (' + count + ')' : '') + '</a></div>';
    done.insertBefore(box, done.firstChild);
  }

  function onSignedIn() {
    signedOut = false;
    window.ttSignedInHere = true; // Back in Stock fills in their email from here on (back-in-stock.js)
    config.isLoggedIn = true;
    var wl = window.themeWishlist;
    if (wl && wl.state) wl.state.loggedIn = true;
    var product = pending;
    pending = null;
    if (toWishlist && !product) { toWishlist = false; window.location.href = PAGE; return; }
    // On the wishlist page: reload so it shows the account's list (guest saves merged in).
    if (window.location.pathname === PAGE) { window.location.reload(); return; }
    if (!product || !wl) return;
    savedShown = true;
    showSaved(null, 0);
    var fill = function () { loadInfo(product).then(function (i) { if (savedShown) showSaved(i, listCount()); }); };
    if (wl.isWishlisted(product.empi, product.epi)) { fill(); return; }
    wl.add(product, function (ok) {
      if (!ok) { savedShown = false; clearSaved(); console.warn('[wishlist] save after sign-in failed'); return; }
      fill();
    });
  }

  function hook() {
    var member = window.ttMember;
    if (!member || member.__ttWl) return !!member;
    var original = member.signedIn;
    member.signedIn = function () {
      var out = typeof original === 'function' ? original.apply(member, arguments) : undefined;
      try { onSignedIn(); } catch (e) { console.warn('[wishlist sign in]', e); }
      return out;
    };
    member.__ttWl = true;
    return true;
  }
  if (drawer) {
    new MutationObserver(function () {
      if (drawer.classList.contains('is-open')) return;
      if (savedShown) { savedShown = false; clearSaved(); }
      if (signedOut) { pending = null; toWishlist = false; } // closed without signing in: the 6th piece is let go
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // A save only counts when the shopper just tapped a heart (or its size picker), so lists that change on
  // their own (Swym merging a guest list after sign-in) never open the card.
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('wishlist-button, [class*="wishlist"]') && !event.target.closest('.tt-wlc, .tt-wls')) tapped = Date.now();
  }, true);

  // swym-wishlist.js announces every change to the list ("wishlist:change"). One new piece since the last
  // change, right after a tap = the shopper just saved it. The first ready list is only the starting point.
  var wl0 = window.themeWishlist;
  var lastKeys = wl0 && wl0.state && wl0.state.ready ? new Set(wl0.state.keys) : null;
  document.addEventListener('wishlist:change', function (event) {
    var d = event.detail || {};
    if (!d.ready || !d.keys) return;
    var keys = Array.from(d.keys);
    var before = lastKeys;
    lastKeys = new Set(keys);
    if (!before || Date.now() - tapped > 20000) return;
    var fresh = keys.filter(function (k) { return !before.has(k); });
    if (fresh.length !== 1 || keys.length !== before.size + 1) return;
    var item = (d.items || []).filter(function (i) { return i.empi + ':' + i.epi === fresh[0]; })[0];
    if (!item || !item.du) return;
    tapped = 0;
    if (savedShown) return; // the drawer already shows it (just signed in from the 6th save)
    // Guests: the Sign In invitation on the first save of a visit only; after that, the quiet card (Nov 1).
    var mode = 'signed';
    if (signedOut) {
      var asked = false;
      try { asked = sessionStorage.getItem('tt_wl_invited') === '1'; sessionStorage.setItem('tt_wl_invited', '1'); } catch (e) {}
      mode = asked ? 'quiet' : 'guest';
    }
    show(mode, item, keys.length);
  });

  function start() { if (!hook()) setTimeout(start, 150); }
  if (signedOut) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }

  window.ttWishlistSignIn = {
    // The 6th save (swym-wishlist.js, instead of saving).
    save: function (product) {
      if (!signedOut) return false;
      show('save', product, listCount());
      return true;
    }
  };
})();
